<template>
    <div class="motionSection reveal" ref="circontents">
<!--         <div class="sectionTitle black fsTitle">
            <splitter :content="localize(sectionData.title)"></splitter>
        </div>
 -->        
        <div class="stickySec">
            <div class="bnCols">
                <!--{{sectionScrollProg.index}}{{sectionScrollProg.prog}}-->         
                <div class="bncolsCircles">
                    <figure :style="getImgStyle(index)" 
                        class="bnCircle" v-for="(item, index) in sectionData.items" 
                        :key="'bnimg_'+index">
                        <img :src="item.img" />
                    </figure>
                </div>
                <div :class="['bnColsContent',sectionProgress<0.02 ? 'centered':'']">
                    <div class="bnItem" :style="'--index:'+index" v-for="(item,index) in sectionData.items" :key="'colitem_'+index">
                        <div class="bnItemTitle" :style="getTitleStyle(index)">
                            <!-- {{sectionProgress}} -->
                            <!-- {{styles[index].partProg}} -->
                            0{{index+1}}. {{localize(item.title)}}
                        </div>
                        <div class="bnDescWrapper" :style="getDescStyle(index)">
                            <div class="bnItemDesc">{{localize(item.content)}}</div>                                                      
                        </div> 
                        <div class="bnBorder"></div> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
  .motionSection
  {    
    height: 300vh;
    color: #fff;
  }
  .stickySec
  {
    position: sticky;
    top: 0px;
    display: flex;
    overflow: visible;
    height: 100vh;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 20px;
  }
    .section-title
    {
        font-size: 40px;
        text-align: center;
        color: #fff;
        letter-spacing: 0px;
    }
    .bnCols 
    {
        display: grid;
        justify-items: start;
        align-content:flex-start;
        grid-template-columns: repeat(2, minmax(115px, 1fr));  
        margin:auto;
        width:80vw;
        max-width: 1200px;
        gap: 50px;
        /* border: solid 5px green; */
        height: 70vh;
        padding-top: 80px;
        /* border: solid 2px red; */
        /* grid-row-gap: 2rem;  Will be used instead by browsers that do not support `row-gap` */
        /* row-gap: 2rem; Used by browsers that support `row-gap` */        
    }
    .bnCols .bncolsCircles
    {
        position: relative;
        width: 100%;
        height: 100%;
    }
    .bnCols .bncolsCircles figure
    {
        position: absolute;
        top:50%;
        left: 50%;
        transform: translate3d(-50%,-50%,0);
        transition: all ease 0.3s;
    }
    .bnCols .bncolsCircles figure img
    {
        width: 400px;
        height: 400px;
        border-radius: 100%;
    }
    .bnCols .bnColsContent
    {
        width: 100%;
        position: relative;
        left: 0%;
        transition: all ease 0.4s;
    }
    .bnCols .bnColsContent.centered
    {        
        left: -50%;
    }

    .bnItem
    {
        color: #3c3c3c;        
        padding-top: 6px;
        padding-bottom: 6px;      
    }
    .bnBorder
    {
        height: 10px;
        max-height: 10px;
        overflow: hidden;
        border-bottom: solid 1px #3c3c3c;  
        width: 100%;
    }
    .bnItem:nth-last-child(1)
    {
        border:0px;
    }
    .bnItemTitle
    {
        font-size: 22px;
        font-weight: 600;
        transition: all ease 0.3s;
    }
    .bnDescWrapper
    {
        overflow: hidden;
        height: 0px;
        transition: all ease 0.2s;
    }
    .bnItemDesc
    {
        font-size: 18px;
        padding-top: 15px;
    }

    .reveal .bnItem
    {
        opacity: 0;
        transform: translateY(20px);        
        transition: all 0.8s cubic-bezier(0.645, 0.045, 0.355, 1.000);
        transition-delay: calc(var(--index) * 0.2s);
    }
    .reveal.active .bnItem
    {
        transform: translateY(0px);
        opacity: 1;
    }
    /*
    .reveal .bnItem .bnBorder
    {
        transition: all 0.8s cubic-bezier(0.645, 0.045, 0.355, 1.000);
        transition-delay: calc(var(--index) * 0.2s);
    }
    .reveal.active .bnItem .bnBorder
    {
        width: 100%;
    }*/

    @media (min-width: 850px) { 
    }

    @media (max-width: 850px) { 

    }    

    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {
    }    

</style>

<script>
import { mapActions, mapState } from "vuex";
import sidepager from "@/views/com/sidepager.vue";
import splitter from "@/views/com/splitter.vue";
import { splitLines,isMobileScreen }         from "@/utils";

export default 
{
    components: { sidepager,splitter },
    data()
    {
        return{
            sectionProgress:0,
            arrTextH:[],
            secIndex:1,
            name:'benefits',
            selectedIndex:0,
            elementTitle:'',
            elementDesc:'',            
            sizerTitle:'',
            sizerContent:'',
            maxTextHeight:0,
            intChanger:Object,
            isAutoChanging:false,
            styles:[]
        }
    },
    props:{
        sectionDataIndex:Number,
        sectionScrollProg:Object
    },
    mounted()
    {
        let vm = this;
        setTimeout(() => {
            vm.collectHeights();
            //vm.updateStyles();//create the array
        }, 500);
        //setTimeout(() => {
            //this.setTextRectSize();    
        //}, 500);        
        //this.initImgScroller();        
        //this.setText();
    },
    destroyed() {
        this.removeImgScroller();
    },
    computed: {
        ...mapState(["xSelectedPlatform","siteData","siteDataReady","siteVisibleSection"]),
        sectionData()
        {
            return this.siteData.SECTIONS[this.sectionDataIndex];
        }
    },
    watch: {
        //sectionScrollProg
        '$store.state.sectionScrollProg': function() {
            //alert("updatung");
            //alert(this.sectionDataIndex);
            if(this.sectionScrollProg.index==this.sectionDataIndex)
            {
                this.updateStyles();
            }
        },
      '$store.state.siteVisibleSection': function() {
        var vm=this;        
        let _siteVisibleSection = this.$store.state.siteVisibleSection;        
        if(_siteVisibleSection==this.sectionDataIndex+1){
            //alert("start auto timer");
            //start the timer
            if(isMobileScreen()==false){
                //vm.startAutoChange();
            }
        }else
        {
            vm.stopAutoChange();
        }
      }
    },

    methods:
    {
        collectHeights()
        {
            let vm =this;
            vm.style = [];
            vm.arrTextH = [];
            let items = vm.$el.querySelectorAll(".bnItemDesc");
            for (var i = 0; i < items.length; i++) 
            {
                let br = items[i].getBoundingClientRect();
                vm.arrTextH.push(br.height);

                let itemStyle = {
                    textH:0,
                    alpha:0.5
                };
                vm.styles.push(itemStyle);
            }
            vm.updateStyles();
        },
        updateStyles()
        {
            //UPDATING ALL THE STYLES OF THE COMPONENT ACCORDING TO THE SCROLL PROGRESS
            //styles[]
            var vm=this;
            if(this.arrTextH.length>0)
            {
                let secProg = this.sectionScrollProg.prog; //precentage of the section
                vm.styles = [];

                for(let i=0;i<this.arrTextH.length;i++)
                {
                    let newH = 0;//
                    let rectH = this.arrTextH[i];                    
                    let partSize = 1/this.arrTextH.length;

                    let itemStart = partSize*i;
                    let itemEnd = itemStart+partSize;                    
                    let delta = itemEnd - secProg;

                    let partProg = 1 - (Math.abs(delta)/partSize);
                    let realPartProg = 1 - (delta/partSize);

                    vm.sectionProgress = this.sectionScrollProg.prog;///////<<<<<<<test

                    newH = rectH*partProg;
                    if(newH>20)
                    {
                        newH+=20;//add for bottom padding of the text
                    }

                    //calculate the alpha according to the distance
                    let newAlpha = 1;
                    //let newAlpha = 0.2 + (partProg * 0.8);
                    //if(newAlpha<0.2){newAlpha=0.2;}

                    //Position of images
                    let positionProgress = realPartProg;
                    if(positionProgress>2){positionProgress=0;}
                    let newImgTrans = 50-((positionProgress*100)/2)-50;

                    //calculate fontSize
                    let minFontSize = 16;
                    let addFontSizeMax = 16;
                    let itemFontSize = minFontSize + (addFontSizeMax*partProg);
                    if(itemFontSize<minFontSize){
                        itemFontSize=minFontSize;
                    }

                    let itemStyle = {
                        partProg:partProg,
                        textH:newH,
                        alpha:newAlpha,
                        imgPos:newImgTrans,
                        imgSize:partProg < 0 ? 0 : partProg,
                        fontSize: itemFontSize
                    };
                    //if(vm.style.length==this.arrTextH.length){
                        //vm.styles[i] = itemStyle;//array is already full, just update the index
                    //}else{
                        vm.styles.push(itemStyle);//array is initlizing
                    //}
                }    
            }
        },
        getImgStyle(index)
        {
            if(this.styles.length>0){
                //0%,0%,0 bottom (when prog is 0)
                //-50%,-50%,0 middle (when prog is 100%)
                //-100,-100 top
                return "transform: translate3d("+this.styles[index].imgPos+"%,"+this.styles[index].imgPos+"%,0) scale("+this.styles[index].imgSize+")";
                //return "transform: translate3d(0%,0,0) scale("+this.styles[index].imgSize+")";
            }
            return '';
            //transform: translate3d(0,0,0) scale(0.2);
        },
        getTitleStyle(index)
        {
            if(this.styles.length>0){
                let cssData = this.styles[index];
                return 'opacity:'+cssData.alpha+";font-size:"+cssData.fontSize+"px";
            }
            return '';
        },
        getDescStyle(index)
        {
            if(this.styles.length>0){
                return 'height:'+this.styles[index].textH+'px';
            }
            return '';

            if(this.arrTextH.length>0)
            {

                let rectH = this.arrTextH[index];
                let secProg = this.sectionScrollProg.prog; //precentage of the section
                let partSize = 1/this.arrTextH.length; 
                let itemStart = partSize*index;
                let itemEnd = itemStart+partSize;
                let newH = 0;//
                let delta = Math.abs(itemEnd - secProg);
                let partProg = 1 - (delta/partSize);
                //console.log("index="+index+" delta="+delta);
                newH = rectH*partProg;// * this.sectionScrollProg.prog;
                return 'height:'+newH+'px';
            }
            //let items = this.$el;//.circontents;//.querySelectorAll(".bnItem");
            //alert(items);
            //let bnItemDesc = contentElement.querySelectorAll(".bnItemDesc")[0];
            //let bnItemDescEl = bnItem.querySelectorAll(".bnItemDesc")[0];
            //let rect = bnItemDescEl.getBoundingClientRect();
            //let newH = rect.height * this.sectionScrollProg.prog;
            return '';//'height:'+newH+'px';
        },
        stopAutoChange()
        {
            this.isAutoChanging=false;
        },
        startAutoChange()
        {
            var vm=this;
            vm.isAutoChanging = true;
            vm.setAutoTimerNext();
        },
        setAutoTimerNext()
        {            
            var vm =this;
            //alert("vm.isAutoChanging="+vm.isAutoChanging);
            if(vm.isAutoChanging)// && vm.siteVisibleSection==2)
            {
                //alert("setAutoTimerNext");
                setTimeout(() => 
                {
                    vm.moveToNextImage();   //move to the next image
                    vm.setAutoTimerNext(); //set the inerval again
                }, 6500);
            }
        },
        moveToNextImage()
        {
            if(!this.isAutoChanging){
                return false;
            }
            var vm=this;
            let newIndex = vm.selectedIndex+1;
            if(newIndex>vm.sectionData.items.length-1){
                newIndex=0;                    
            }
            vm.setItem(newIndex,true);                
        },
        initImgScroller() {
            if(isMobileScreen()==true)
            {
                var vm = this;
                let scroller = this.$refs.bnImgScroll1;
                scroller.addEventListener("scroll", vm.checkScrollPosition, false);             
            }
        },
        removeImgScroller() {
            if(isMobileScreen())
            {
                var vm = this;
                let scroller = this.$refs.bnImgScroll1;
                scroller.removeEventListener("scroll", vm.checkScrollPosition);
            }
        },
        checkScrollPosition() {
            //alert("benefits scroll");
            var vm=this;
            let scroller = vm.$refs.bnImgScroll1;
            let scrX = scroller.offsetLeft;
            let scrolledX = scroller.scrollLeft;
            
            var reveals = scroller.querySelectorAll(".bnImgItem");
            for (var i = 0; i < reveals.length; i++) 
            {
                //find the element to highligt 
                //console.log("__scrolledX="+scrolledX);
                //console.log("(scrolledX+scrX) ="+scrolledX+"+"+scrX+" === "+reveals[i].offsetLeft);

                //if((scrolledX+scrX)==reveals[i].offsetLeft){
                if((scrolledX)==reveals[i].offsetLeft){
                    //alert("change from scroller");
                    vm.setItem(i,false);               
                    //console.log("[SELECTED !] vm.selectedIndex="+vm.selectedIndex);
                }
            }
        },
        sidepagerOnChange(index)
        {            
            this.setItem(index,false);
        },  
        setItem(index,fromTimer)
        {
            if(fromTimer==false){
                this.stopAutoChange()
            }
            this.selectedIndex = index;            
            this.setText();
            this.scrollImg();
        },
        setText()
        {

            let elData = this.sectionData.items[this.selectedIndex];
            this.elementTitle = elData[0];
            this.elementDesc = elData[1];
        },
        setTextRectSize()
        {
            //This will find the heighest text rect size
            //and will apply to the text wrapper (this.$refs.visibleTextRect)
            //in order to avoid moving the pager below the text
            let rectElement = this.$refs.tempSizingRect; 
            let visibleRectElement = this.$refs.visibleTextRect;

            var rectsList = rectElement.querySelectorAll(".temprect");            
            for (var i = 0; i < rectsList.length; i++) 
            {
                let rectEl = rectsList[i];
                var rect = rectEl.getBoundingClientRect();
                console.log("rect item:"+i+" text height:"+rect.height); 
                if(rect.height>this.maxTextHeight){this.maxTextHeight = rect.height;}
            }
            rectElement.style.display="none";//hide the temp rect
            this.maxTextHeight = this.maxTextHeight + 10;
            visibleRectElement.style.height = this.maxTextHeight + "px";
        },
        scrollImg()
        {
            if(isMobileScreen()){
                //scroll on mobile version
                //let scrollToElement = this.$refs.bnImgScroll1.getElementsByClassName("bnImgItem")[this.selectedIndex];
                //scrollToElement.scrollIntoView({ behavior:'smooth',inline:'center',block:'nearest'});
            }else{
                //fade in/out relevent images on desktop version

            }

        }
    }
};
</script>

